import angular, {IWindowService} from "angular";
import {regNavn} from "./tredjepartsTjenestenavn";
import {Debugger} from "debug";
import {UuidGenerator} from "./UuidGenerator";

const debug:Debugger = require('debug')('InterWindowBus');

/**
 * Tjenste for å sende hendelser til andre nettleserfaner/vinduer under samme domene.
 *
 * Se https://github.com/jcubic/sysend.js/blob/master/sysend.js for mulig ferdig implementasjon.
 */
export class InterWindowBus {

    static regNavn = 'InterWindowBus';

    static forInjisering() {
        return [
            regNavn.ng.$window,
            UuidGenerator.regNavn,
            InterWindowBus
        ]
    }

    constructor(private $window:IWindowService, uuid:UuidGenerator) {
        this.instansid = uuid.generer();
    }

    private instansid:string;
    private lagringsnøkkel = 'lederplan.InterWindowBus';

    ved(hendelse: string, hendelseslytter: (data?:any) => void):Function {
        const handler = (storageEvent:StorageEvent)=>{
            if (storageEvent.key !== this.lagringsnøkkel) return;
            const data = this.deserialiserHendelse(storageEvent.newValue);
            debug("behandler hendelse "+data.hendelse, data)
            if (data.instansid === this.instansid) return; //ikke behandle hendelser vi har sendt via samme instans
            if (data.hendelse !== hendelse) return;
            hendelseslytter(data.data)
        };
        this.$window.addEventListener('storage',handler);

        const avreg = ()=> this.$window.removeEventListener('storage', handler);
        return avreg;
    }

    signaliser(hendelse: string, data:any = null) {
        const serialisert = this.serialiserHendelse(hendelse, data);
        debug("signaliser "+hendelse, serialisert)
        this.$window.localStorage.setItem(this.lagringsnøkkel, serialisert);
    }

    private serialiserHendelse(hendelse: string, hendelsesdata: any) {
        const data: InterTabBusHendelse = {instansid: this.instansid, hendelse: hendelse, data: hendelsesdata, _ts: new Date().getTime()};
        return angular.toJson(data);
    }

    private deserialiserHendelse(jsonData:string) : InterTabBusHendelse{
          const data = angular.fromJson(jsonData);
          return data;
    }
}

interface InterTabBusHendelse{
    instansid:string;
    hendelse:string;
    data:any;
    _ts:number; //denne er kun med for å sikre at lagrede data er endret - ellers fyres ikke storage eventet
}
